// extracted by mini-css-extract-plugin
export default {"assistanceWrapper":"style_assistanceWrapper__mf1VT","assistanceContainer":"style_assistanceContainer__AcdxS","assistanceContainerIcon":"style_assistanceContainerIcon__VRi2F"};